// extracted by mini-css-extract-plugin
export default {"container":"CreditMessage-module__container__n3lJn","title":"CreditMessage-module__title__deVxS","text":"CreditMessage-module__text__hp24m"};